export const MACAO_GAME = {
    minPlayers: 2,
    maxPlayers: 4,
    handSize: 5,
    countdownMs: 5_000,
    turnMs: 45_000,
    reconnectGraceMs: 30_000,
};
export const MACAO_SUITS = ["hearts", "diamonds", "clubs", "spades"];
export const MACAO_RANKS = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K", "A"];
